/* eslint-disable import/prefer-default-export */
import axios from "axios";
import config from "../config";

const BASE_URL_API = `${config.API_URL}/api/v1`;

export const getBookingFiltersByUser = async (userId) => {
  return axios.get(`${BASE_URL_API}/user/${userId}/bookings/filters`);
};
